export default "__VITE_ASSET__BTkCQrsG__"